export function getPixelValue(
  pixel: null | Record<string, Array<string | number>>
) {
  if (!pixel) return null;

  if (pixel.facebook?.length !== 0) {
    return pixel.facebook?.join('_');
  }
}
